import { render, staticRenderFns } from "./jijiu-page-title.vue?vue&type=template&id=47935ef4&scoped=true"
import script from "./jijiu-page-title.vue?vue&type=script&lang=js"
export * from "./jijiu-page-title.vue?vue&type=script&lang=js"
import style0 from "./jijiu-page-title.vue?vue&type=style&index=0&id=47935ef4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47935ef4",
  null
  
)

export default component.exports